import { Navigate, useLocation } from 'react-router-dom'
import { useGrants } from '../../auth/useCurrentUser'
import { ACTION_LIST_ALL_SCOPE_GRANTS, GRANTS, type GrantCode } from '../../auth/grants'
import { ACTION_TAB_SCOPES, type ActionScope } from './types'

/** Kapsam → görüntüleme yetkisi (rota kilidiyle aynı eşleme). */
const SCOPE_GRANTS: Record<ActionScope, readonly GrantCode[]> = {
  // "Tüm Görevler"i iki yetki açar — sınırlı hâli Genel Müdür'de (06.10.2026).
  all: ACTION_LIST_ALL_SCOPE_GRANTS,
  created: [GRANTS.ACTION_LIST_OWN_VIEW],
  assigned: [GRANTS.ACTION_LIST_ASSIGNED_VIEW],
  followed: [GRANTS.ACTION_LIST_FOLLOWED_VIEW],
  // Delegasyon bir SEKME DEĞİL (ACTION_TAB_SCOPES'ta yok) → bu eşleme onu hiç okumaz; girdi yalnız
  // Record tipini tamamlamak için var. Sayfanın gerçek koruması rotadadır (ASSIGNED VEYA OWN).
  delegation: [GRANTS.ACTION_LIST_ASSIGNED_VIEW],
}

/**
 * `/minutes/actions` (Aksiyonlar grup kökü) — kendi ekranı yoktur; kullanıcının yetkili olduğu <b>ilk</b>
 * kapsamın alt sayfasına yönlendirir (sıra: Tüm Aksiyonlar → Oluşturduklarım → Bana Atananlar → Takip
 * Ettiklerim). Aksiyon detay sayfasının "Listeye Dön" fallback'i (origin yoksa) buraya düşer → kullanıcı
 * her zaman yetkili bir listeye iner. Hiç yetki yoksa "all"'a düşer (rota {@code RequireGrant}'i yakalar).
 */
export default function ActionsIndexRedirect() {
  const { hasGrant, isLoading } = useGrants()
  const location = useLocation()
  // Yetkiler yüklenirken bekle (fail-closed; yanlış kapsama sıçramasın).
  if (isLoading) return <div className="page meetings-page" />
  const scope = ACTION_TAB_SCOPES.find((s) => SCOPE_GRANTS[s].some((g) => hasGrant(g))) ?? 'all'
  // Query'yi koru (ör. eski `/minutes/actions?criticalOrOverdue=true` yer imi → filtre kaybolmasın).
  return <Navigate to={`/minutes/actions/${scope}${location.search}`} replace />
}
